export const SET_MENU_EXTRAS_DATA = 'SET_MENU_EXTRAS_DATA';
export const TOGGLE_EXTRA_MODAL = 'TOGGLE_EXTRA_MODAL';
export const TOGGLE_SECTION_MODAL = 'TOGGLE_SECTION_MODAL';
export const SET_MENU_ITEMS_DATA = 'SET_MENU_ITEMS_DATA';